module.exports = __webpack_public_path__ + "static/media/step-2-outline.9c6b6804.svg";